import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { FadeZoomInTop } from '../../animations/fade-zoom-in-top.decorator';
import { SessionSetting, AppHttp, Resources } from '../../../app.service';
import { KeycloakService } from '../../../keycloak.service';

declare var config: any;
// jQuery 
declare var $: any;

@FadeZoomInTop()
@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styles: []
})
export class MainLayoutComponent implements OnInit {

  @ViewChild('navPanel', {read: ElementRef}) navContainer ;
  @ViewChild('mainPanel', {read: ElementRef}) mainContainer ;
  @ViewChild('ribbon', {read: ElementRef}) ribbonContainer ;
  constructor(private router: Router) { }

  ngOnInit() {
    let user: any = {};
    if (config.devMode) {
      user = SessionSetting.getUser();
      if (user == null || user.UserID == null || user.RoleIDs == null) {
        this.router.navigate(['login']);
        return;
      }
      user.IS_LOGINED = 1;
    } else {
      if (KeycloakService.auth == null
          || !KeycloakService.auth.loggedIn
          || KeycloakService.auth.authz == null) {
        KeycloakService.init();
        return;
      }
      let authz = KeycloakService.auth.authz;
      user.UserID = authz.idTokenParsed.preferred_username;
      user.IS_LOGINED = 1;
      user.RoleIDs = authz.resourceAccess[authz.clientId].roles;
    }
    SessionSetting.setUser(user);
  }

  ngAfterViewInit() {
    let aside = $(this.navContainer.nativeElement).children("aside");
    let ul = aside.children("nav").children("ul");
    let mainElement = $(this.mainContainer.nativeElement);
    let ribbonElement = $(this.ribbonContainer.nativeElement).children("div");
    
    aside.resizable({ handles: 'e', minWidth:50});
    aside.resize((e) => {
      this.asidResize(aside, ul, mainElement, ribbonElement);
      setTimeout(() => {
        this.asidResize(aside, ul, mainElement, ribbonElement);
      }, 300);
    });
  }

  asidResize(aside, ul, mainElement, ribbonElement){

    let marginLeft = Number(aside.css('width').replace('px', ''));
    let mobileView = $('body').hasClass('mobile-view-activated');
    if(mobileView){
      return;
    }
    else{
      let fixedNav = $('body').hasClass('fixed-navigation');
      if (fixedNav) {
        ul.css('width', marginLeft + 31);
      }
      else {
        ul.css('width', '');
      }
    }
    
    let asideLeft = Number(aside.css('left').replace('px', ''));
    marginLeft = marginLeft + asideLeft - 2;
    mainElement.css('margin-left', marginLeft);
    let fixedRibbon = $('body').hasClass('fixed-ribbon');
    if (fixedRibbon) {
      ribbonElement.css('left', marginLeft);
    }
    else{
      ribbonElement.css('left', '');
    }
  }
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/shared/layout/app-layouts/main-layout.component.ts